<script setup lang="ts">
import ContactsBody from './ContactsBody.vue';
import {
  SEO_TITLE,
  SEO_DESCRIPTION,
  OG_TYPE,
  OG_SITE_NAME,
  getOgImageMeta,
} from '~/shared/lib/seo';
import { useOrigin } from '~/shared/lib/useOrigin';

const origin = useOrigin();
const title = SEO_TITLE.replace('%%TITLE%%', 'Контакты');
const canonicalUrl = origin + '/contacts_main';
useHead({
  title: title,
  link: [{ rel: 'canonical', href: canonicalUrl }],
  meta: [
    { name: 'description', content: SEO_DESCRIPTION },
    { property: 'og:type', content: OG_TYPE },
    { property: 'og:title', content: title },
    { property: 'og:description', content: SEO_DESCRIPTION },
    { property: 'og:site_name', content: OG_SITE_NAME },
    ...getOgImageMeta(origin),
  ],
});

const CONTACTS_SUBTITLE =
  'Учредитель ООО «ТУ БИ ПРЕСС»<br>ИНН 9718284122, 107023, г. Москва, ул. Электрозаводская, д. 20, стр. 3';
</script>

<template>
  <div>
    <PageHeader
      title="Контакты"
      :subtitle="CONTACTS_SUBTITLE"
      :show-border-bottom="false"
    />
    <ContactsBody />
  </div>
</template>

<style scoped lang="scss"></style>
